import { Row, Col, Tabs, Tab, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Price from 'components/Price';

const Package = ({ active, value, price, onChange }) => {
  const { t } = useTranslation();
  const { leasingPeriod } = useSelector(state => state.config);
  return (
    <div className={`c-package ${active ? 'is-active' : ''}`}>
      {/*<figure className="c-package__img">
        <span className="c-package__code">{item.code}</span>
      </figure>*/}
      <div className="c-package__body">
        <span className="c-package__title">{value} {t('leasing_miles_per_months', { months: leasingPeriod })}</span>
      </div>
      <div className="c-package__footer">
        <strong className="c-package__price c-price"><Price price={price} /></strong>
        <Button
          className="c-package__btn"
          variant={active ? "primary" : "secondary"}
          size="sm"
          onClick={() => onChange({ leasingMileage: value })}
        >
          <svg className="btn-ico btn-ico-left" viewBox="0 0 20 20">
            <path className="btn-ico-bg" d="M10 19.1c5 0 9.1-4.1 9.1-9.1S15 .9 10 .9.9 5 .9 10 5 19.1 10 19.1zm0 .9C4.5 20 0 15.5 0 10S4.5 0 10 0s10 4.5 10 10-4.5 10-10 10z"></path>
            <path className="btn-ico-sign" d={active ? "M13.3 9.5v1.1H6.8V9.5h3.9z" : "M13.3 9.5v1.1h-2.6v2.8H9.5v-2.8H6.8V9.5h2.7V6.8h1.2v2.7z"}></path>
          </svg>
          {t('choose_body_button')}
        </Button>
      </div>
    </div> 
  );
};

const PackagePeriod = ({ active, value }) => {
  const { t } = useTranslation();
  return (
    <div className={`c-package ${active ? 'is-active' : ''}`}>
      <div className="c-package__body">
        <span className="c-package__title">{t('leasing_period')}</span>
      </div>
      <div className="c-package__footer">
        <strong className="c-package__price c-price">{value} {t('leasing_mth')}</strong>
      </div>
    </div> 
  );
};

const PackageLeasing = ({ active, value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className={`c-package ${active ? 'is-active' : ''}`}>
      <div className="c-package__body">
        <span className="c-package__title">{t('leasing_insurance')}</span>
      </div>
      <div className="c-package__footer">
        <strong className="c-package__price c-price"><Price price={value} /></strong>
        <Button
          className="c-package__btn"
          variant={active ? "primary" : "secondary"}
          size="sm"
          onClick={() => onChange({ leasingInsurance: !active })}
        >
          <svg className="btn-ico btn-ico-left" viewBox="0 0 20 20">
            <path className="btn-ico-bg" d="M10 19.1c5 0 9.1-4.1 9.1-9.1S15 .9 10 .9.9 5 .9 10 5 19.1 10 19.1zm0 .9C4.5 20 0 15.5 0 10S4.5 0 10 0s10 4.5 10 10-4.5 10-10 10z"></path>
            <path className="btn-ico-sign" d={active ? "M13.3 9.5v1.1H6.8V9.5h3.9z" : "M13.3 9.5v1.1h-2.6v2.8H9.5v-2.8H6.8V9.5h2.7V6.8h1.2v2.7z"}></path>
          </svg>
          {t('choose_body_button')}
        </Button>
      </div>
    </div> 
  );
};

const Leasing = ({ onChange }) => {
  const { t } = useTranslation();
    const { specification, gradeId, leasingMileage, leasingPeriod, leasingInsurance } = useSelector(state => state.config);
    const { leasingData, eicsData, builderData } = useSelector(state => state.data);
    //const { options = [], equipment = [] } = builderData;

    //const categories = [...new Set([...options, ...equipment].map(item => item.categoryName || 'OTHER'))];

    const opts = (builderData.leasing.period?.find(item => item.value === leasingPeriod)?.mileage || []).filter(item => item.price !== null);
    const insurance = builderData.leasing.period?.find(item => item.value === leasingPeriod)?.greenvalInsurance?.price;

    return (<>
        <h5 className="c-section__subtitle">{t('leasing_options')}</h5>
        <Row className="mt-5">
          <Col sm="6" lg="3" className="mb-4">
            <PackagePeriod
              active={!!leasingPeriod}
              value={leasingPeriod}
            />
          </Col>
          {opts.map((item) => {
            const isChecked = leasingMileage === item.value;
            //if (!item.price) return null;
            return (
              <Col sm="6" lg="3" className="mb-4" key={item.value}>
                <Package
                  active={isChecked}
                  value={item.value}
                  price={item.price}
                  onChange={onChange}
                />
              </Col>
            );
          })}
          {!!insurance && (
            <Col sm="6" lg="3" className="mb-4">
              <PackageLeasing
                active={!!leasingInsurance}
                value={insurance}
                onChange={onChange}
              />
            </Col>
          )}
        </Row>
    </>);
};

export default Leasing;
